import { stringify } from "querystringify"

import { ResultsDataBase, SurveyResultsStorage } from "../../../common/utils/SurveyResultsStorage"

import { save } from "modules/NewClientSurvey/components/StepTwoQuestions/helpers/save"
import {
    buildCatalogQueryString,
    collectSurveyAnswers,
    getCompetenceTitles,
    getValueAfterLastSlash,
    parseCity,
    parseCompetences,
    parsePriceRange,
    parseSex,
    parseSlotType,
    Subject,
    SurveyAnswer,
    SurveyQuestions,
} from "modules/NewClientSurvey/common"
import { findQuestionChoiceByRef } from "modules/NewClientSurvey/common/utils/findQuestionChoiceByRef"
import { CATALOG_PATH } from "modules/PsyCatalog/common/utils"
import { MAX_PRICE, MIN_PRICE } from "modules/PsyProfile/common/constants"
import { ReportedProblemsStorage } from "utils/ReportedProblemsStorage"

export async function sendAnswersGetProfiles(
    answers: Record<string, SurveyAnswer>,
    surveyQuestions: SurveyQuestions,
    slug: string
): Promise<string> {
    const subject = surveyQuestions.slug

    const reportedProblemTitles = getCompetenceTitles(surveyQuestions, answers)

    const findFormOfWorkByRef = findQuestionChoiceByRef(
        surveyQuestions.questions,
        answers,
        "form_of_work"
    )
    const formOfWork = parseSlotType(findFormOfWorkByRef)
    const city = parseCity(findQuestionChoiceByRef(surveyQuestions.questions, answers, "city"))

    const findPriceByRef = findQuestionChoiceByRef(
        surveyQuestions.questions,
        answers,
        "price_category"
    )
    const priceRange = parsePriceRange(findPriceByRef)

    const findSexByRef = findQuestionChoiceByRef(surveyQuestions.questions, answers, "sex")
    const sex = parseSex(findSexByRef)
    const competences = parseCompetences(
        findQuestionChoiceByRef(surveyQuestions.questions, answers, "reported_problems")
    )

    const searchFormData = {
        subject,
        city,
        form_of_work: formOfWork,
        sex,
        competences,
        price_from: priceRange.min || MIN_PRICE,
        price_to: priceRange.max || MAX_PRICE,
    }

    const collectedAnswers = collectSurveyAnswers(answers)
    const value = getValueAfterLastSlash(slug)
    const result = await save(collectedAnswers, value)

    ReportedProblemsStorage.store({
        reported_problems_id: result.fallback_competences || [],
    })
    const payload: ResultsDataBase = {
        ...result,
        title: surveyQuestions.subtitle,
        reported_problems: reportedProblemTitles.join("% "),
        reported_problems_id: result?.fallback_competences || [],
        subject: surveyQuestions.slug as Subject,
        slug: surveyQuestions.slug,
        fallback_competences: [],
        ...(result.questionnaire_results_id
            ? { questionnaire_results_id: result.questionnaire_results_id }
            : {}),
        ...(findSexByRef ? { sex } : {}),
        ...(findFormOfWorkByRef ? { form_of_work: formOfWork } : {}),
        ...(priceRange.min !== 0 && findPriceByRef ? { price_min: priceRange.min } : {}),
        ...(priceRange.max !== 0 && findPriceByRef ? { price_max: priceRange.max } : {}),
        ...(findPriceByRef ? { price_category: priceRange.category } : {}),
    }

    SurveyResultsStorage.store(payload)

    const qs = buildCatalogQueryString(searchFormData, result.fallback_competences || [])

    if (!result.profiles.length) {
        const manualQs = {
            manual: 1,
            ...qs,
        }
        return `${CATALOG_PATH.root}?${stringify(manualQs)}`
    }

    return `/survey/psy/result?${stringify(qs)}`
}
